import { useEffect, useState } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { useNavigate } from "react-router-dom";
// -
import { SwalAlertClass } from "core/swalClass";
import { MessageModel } from "site-apps/notifications/MessageModel";
import axiApi from "ApiCaller";
import WsConnector from "core/wsConnector";
import MessageHeader from "./MessageHeader";

const Message = ({ item, userLang = "es" }) => {
    const navigate = useNavigate();
    const [message, setMessage] = useState({ ...MessageModel });
    const [progress, setProgress] = useState("");
    const Alert = new SwalAlertClass({ confirmButtonText: "Aceptar" });
    const wsConn = new WsConnector();
    wsConn.message = (e) => {
        let data = JSON.parse(e.data);
        setProgress(data.message);
        if (data.ended) {
            wsConn.close();
            navigate(0);
        }
    };
    // -
    useEffect(() => {
        if (item && item.id) {
            if (item.notify && item.notify.params && item.notify.params.task_id && !item.notify.params.ended) {
                wsConn.setUrl(`/ws/tasknotify/${item.notify.params.task_id}/`);
                wsConn.connect();
            }

            const texts = item.notify.texts || {};
            const text = texts[userLang] || texts["es"] || texts[Object.keys(texts)[0]] || {};

            setMessage({
                ...item,
                notify__title: text.title || "",
                message: text.description || "",
            });
            setProgress("");
        } else {
            setMessage({ ...MessageModel });
            setProgress("");
        }
        return () => {
            wsConn.close();
        };
    }, [item, userLang]);
    // -
    const onClickLink = (e) => {
        let link;
        if (e.target.tagName === "button") {
            link = e.target.dataset.link;
        } else {
            link = e.currentTarget.dataset.link;
        }
        if (!link) {
            Alert.error("Archivo", "No se pudo encontrar la referencia del archivo");
            return false;
        }
        axiApi
            .get(link, {
                responseType: "blob",
            })
            .then((resp) => {
                const contentDisposition = resp.headers["content-disposition"];
                const contentType = resp.headers["content-type"];
                let filename = "downloaded-file";
                if (contentDisposition) {
                    const filenameMatch = contentDisposition.match(/filename="?([^"]+)"?/);
                    if (filenameMatch.length === 2) {
                        filename = filenameMatch[1];
                    }
                }
                const blob = new Blob([resp.data], { type: contentType });
                const urlBlob = window.URL.createObjectURL(blob);
                const linkTemp = document.createElement("a");
                linkTemp.href = urlBlob;
                linkTemp.setAttribute("download", filename);

                document.body.appendChild(linkTemp);
                linkTemp.click();
                document.body.removeChild(linkTemp);
            })
            .catch((error) => {
                console.log(error);
                Alert.error("Error", "Al descargar el archivo, se produjo un error: " + error.message);
            });
    };

    const onOpenProcessMonitor = () => {
        navigate(`/process/monitor/${item.notify.params.task_id}`);
    };

    return (
        <>
            {message != null && message.id ? (
                <div className="container-fluid">
                    <MessageHeader
                        message={message}
                        userLang={userLang}
                        onClickLink={onClickLink}
                        onOpenProcessMonitor={onOpenProcessMonitor}
                    />
                    <div className="row">
                        <div
                            className="col-12"
                            dangerouslySetInnerHTML={{
                                __html: message.message,
                            }}
                        />
                        {progress !== "" && <div className="col-12" dangerouslySetInnerHTML={{ __html: progress }} />}
                    </div>
                </div>
            ) : (
                <div className="app-notify-empty">
                    <div style={{ paddingBottom: "30px" }}>
                        <FontAwesomeIcon icon="fa-solid fa-envelope" size="2xl" />
                    </div>
                    <div>
                        <p>Seleccione una notificación para leer</p>
                    </div>
                </div>
            )}
        </>
    );
};

export default Message;